import React from "react";

const DocumentIcon = (props) => (
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.35,4.5a2,2,0,0,0-1.95,2v35.1a2,2,0,0,0,1.95,2h27.3a2,2,0,0,0,2-2V14.49h-8a2,2,0,0,1-1.95-2v-8Z" />
    <line x1="29.61" y1="4.5" x2="39.6" y2="14.49" />
    <line x1="15.84" y1="22.97" x2="32.16" y2="22.97" />
    <line x1="15.84" y1="35.07" x2="32.16" y2="35.07" />
    <line x1="15.84" y1="29.02" x2="32.16" y2="29.02" />
  </svg>
);

export default DocumentIcon;
